/** @format */
import {Typography} from '@mui/material';

import {Container} from './styles';

interface BriefInfoProps {
  summaryInfo: string;
}

const BriefInfo = ({summaryInfo}: BriefInfoProps) => {
  if (!summaryInfo) return null;

  const firstDotIndex = summaryInfo.indexOf('.');

  if (firstDotIndex === -1) {
    return (
      <Container>
        <Typography data-testid='brief-info-single'>{summaryInfo}</Typography>
      </Container>
    );
  }

  const firstSentence = summaryInfo.substring(0, firstDotIndex + 1).trim();
  const restText = summaryInfo.substring(firstDotIndex + 1).trim();

  return (
    <Container>
      <Typography data-testid='brief-info-first'>{firstSentence}</Typography>
      {restText && (
        <Typography data-testid='brief-info-rest'>{restText}</Typography>
      )}
    </Container>
  );
};

export default BriefInfo;
